import React, { Component } from 'react';
import { ILayout } from '../backend';
import { IFields, IPageFields, Steps } from '../types/state';
import FormPage from './FormPage';
import SubComponents from './subcomponents/SubComponents';

interface IProps {
  layout?: ILayout;
  onValueChange: (field: string, value: any, step: Steps, valid?: boolean) => void;
  onSubmit: () => void;
  onCancel: () => void;
  shiftClientPreferences: IPageFields;
  valid: boolean;
  errorMessage?: string;
}

class ShiftClientPreferences extends Component<IProps> {
  public state = {};

  public render(): JSX.Element {
    const {
      layout,
      shiftClientPreferences,
      onValueChange,
      valid,
      onSubmit,
      onCancel,
      errorMessage,
    } = this.props;
    return (
      <FormPage
        layout={layout}
        valid={valid}
        onSubmit={onSubmit}
        onCancel={onCancel}
        enablePrev={true}
        errorMessage={errorMessage}
      >
        <h3 className='form-title'>Shift and Client Preferences</h3>
        <p className='form-title'>
          Please fill out some basic information to help us determine the best shift matches should
          you meet our employment criteria.
        </p>
        <div className='single-column-experience-container'>
          {shiftClientPreferences.fields
            ?.filter((f: IFields) => f.visible)
            .map((f: IFields) => {
              const value = f.value;
              return (
                <SubComponents
                  key={f.id}
                  value={value}
                  field={f}
                  step='shiftClientPreferences'
                  onValueChange={onValueChange}
                />
              );
            })}
        </div>
      </FormPage>
    );
  }
}

export default ShiftClientPreferences;
